var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('Breadcrumb',{attrs:{"pgTitle":_vm.$t('nav.settings'),"pgIcon":'bx bx-wrench',"refs":_vm.refs,"addNew":_vm.addNew}}),_c('Cards',{attrs:{"refs":_vm.refs}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }